<div class="view-search" gaCategory="View Search">
    <div class="view-search__header">
        <!-- Search Header -->
        <div class="view-search__actions-row">
            
            <div class="view-search__actions">
                <button
                    gaEvent
                    gaAction="Clicked Anatomy Tree"
                    type="button"
                    class="view-search__action"
                    (click)="handleTreeButtonClick()"
                    [ngClass]="{'view-search__action--selected': (searchDisplayMode$ | async) === treeSearchDisplayMode.Tree}"
                    [matTooltip]="'Switch to Anatomy Tree'"
                    aria-label="Switch to Anatomy Tree">
                        <app-icon
                            class="view-search__action-icon"
                            aria-hidden="true"
                            [icon]="'sitemap'">
                        </app-icon>Tree
                </button>

                <button
                    gaEvent
                    gaAction="Clicked Search"
                    type="button"
                    class="view-search__action"
                    (click)="handleListButtonClick()"
                    [ngClass]="{'view-search__action--selected': (searchDisplayMode$ | async) === treeSearchDisplayMode.List}"
                    [matTooltip]="'Switch to Search'"
                    aria-label="Switch to Search">
                        <app-icon
                        class="view-search__action-icon"
                        aria-hidden="true"
                        icon="search">
                        </app-icon>Search
                </button>
            </div>

            <!-- Exit -->
            <button
                gaEvent
                gaAction="Clicked Exit"
                type="button"
                class="view-search__exit"
                (click)="handleExitClick()"
                matTooltip="Close Search"
                aria-label="Close Search">
                <app-icon icon="times"></app-icon>
            </button>
        </div>
        
        <div class="view-search__input-row">
            <div class="view-search__input-container">
                <app-icon class="view-search__input-icon" icon="search"></app-icon>
                <!-- Search -->
                <input
                    appAutoFocus
                    appSelectOnFocus
                    #searchInput 
                    role="search"
                    type="text"
                    class="view-search__input"
                    aria-label="Search Anatomy"
                    placeholder="Search Anatomy"
                    [value]="query"
                    (keyup)="handleSearchKeyup($event,searchInput.value)">
            </div>
        </div>
    </div>

    <div class="view-search__body">
        <app-tree-search
            [displayMode]="searchDisplayMode$ | async"
            [theme]="treeTheme.Themed"
            [query]="query"
            [viewGraph]="viewGraph$ | async">
        </app-tree-search>
    </div>
</div>
